module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'rfcqed4j',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
